export const LOGO_URL = "/lenax-logo-dark.jpg";

export const LOGO_LIGHT_URL = "/lenax-logo.png";

export const COMPANY = {
  name: "Lenax Pharmaceuticals",
  legal: "Lenax Pharmaceuticals Pvt. Ltd.",
  tagline: "Leading You To Better Health",
  founded: "2020",
  founders: ["Ashmeet Singh Arora", "Vikram Nimbalkar"],
  email: "contact@lenax.life",
  info_email: "contact@lenax.life",
  address: "Amravati MIDC, Maharashtra, India",
};
